import { createReducer } from "@reduxjs/toolkit";

import {
  addStripe,
  addStripeFailure,
  addStripeSuccess,
  clearAddStripeStates,
  getStripeCountries,
  getStripeCountriesFailure,
  getStripeCountriesSuccess,
} from "./actions";

const initialState = {
  data: {},
  isLoading: false,
  isSuccess: false,
  error: null,
  countries: [],
  isCountriesLoading: false,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(addStripe.type, (state) => ({
      ...state,
      isSuccess: false,
      isLoading: true,
      error: initialState.error,
    }))
    .addCase(addStripeSuccess.type, (state, action) => ({
      ...state,
      ...action.payload,
      error: initialState.error,
      isSuccess: true,
      isLoading: false,
    }))
    .addCase(addStripeFailure.type, (state, action) => ({
      ...state,
      error: action.payload,
      isLoading: false,
    }))
    .addCase(getStripeCountries.type, (state) => {
      state.isCountriesLoading = true;
    })
    .addCase(getStripeCountriesSuccess.type, (state, { payload }) => {
      state.countries = payload;
      state.isCountriesLoading = false;
    })
    .addCase(getStripeCountriesFailure.type, (state) => {
      state.isCountriesLoading = false;
    })
    .addCase(clearAddStripeStates.type, () => ({
      ...initialState,
    }));
});
